export default __webpack_public_path__ + "static/media/jquery.92428ea4.png";